import { render, RenderOptions } from '@testing-library/react';
import { createMemoryHistory } from 'history';
import React, { ReactElement } from 'react';
import { Router } from 'react-router';

export const history = createMemoryHistory();

const AllTheProviders: React.FC = ({ children }) => {
  return (
      <Router history={history}>
        {children}
      </Router>
  );
};

const customRender = (ui: React.ReactElement, options?: Omit<RenderOptions, 'queries'>) =>
    render(ui, { wrapper: AllTheProviders, ...options });

export const renderHook = <T,>(hook: () => T) => {
  const result = { current: null as T };

  const TestComponent = (): ReactElement | null => {
    result.current = hook();
    return null;
  };

  customRender(<TestComponent />);
  return result;
};

// re-export everything
export * from '@testing-library/react';

// override render method
export { customRender as render };
